import { Config } from '@shared/config';

export class FiltersParams {
  filters_category?: string = '';
  filters_continent?: string = '';
  filters_featured?: string = '';
  filters_country?: string = '';
  filters_last_days?: string = '';
  order_by?: string = '';
  search?: string = '';
  autofocus?: string = '';
  ranking?: string = '';
  page?: string = '1';
  per_page?: number = Config.PER_PAGE_DEFAULT;
  api_url: string = '';
  ended?: string = '';
  filters_excluded_tags?: string = '';
  filters_status?: string = '';

  constructor(data?: any) {
    data ? Object.assign(this, data) : null;
  }
}
